module.exports = __webpack_public_path__ + "static/WORLD2-ba443b13b613cfedfe78af21e7756253.jpg";